import React from 'react';
import Query from '../../../../graphql/Query';
import CategoryListView, { CategoriesListViewProps } from './CategoryListView';
import { GET_CATEGORIES } from '../../graphql';

const CategoryList = () => (
    <Query<CategoriesListViewProps> query={GET_CATEGORIES}>
        {({ data: { categories, categoriesProductCount } }) => (
            <CategoryListView
                categoriesProductCount={categoriesProductCount}
                categories={categories}
            />
        )}
    </Query>
);

export default CategoryList;
